module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=ES - Spain.754a3d65.svg";